import { progressBar } from "hooks/useProgressBar";

import apolloClient from "./apolloClient";

export default async function fetchData(query, variables, { ...options } = {}) {
  const queryOptions = {
    query,
    variables,
    errorPolicy: "none",
    ...options,
  };

  const { data } = await progressBar(() => apolloClient.query(queryOptions));

  return data;
}
